export default {
    PasatiempoDeportes: 'Hobby and Sports',
    MisterioTerror: 'Mystery and Horror',
    AventurasViajes: 'Adventures and Travels',
    FantasiaMundos: 'Fantasy and other Worlds',
    ArteCultura: 'Art and Culture',
    CienciaTecnologia: 'Science and Technology',
    CienciasUniverso: 'Sciences and Universe',
    TecnologiaInventos: 'Technology and Inventions',
    PensamientosEmociones: 'Thoughts and Emotions',
    HistoriaVidaReal: 'History and Real Life',
    HumorCuriosidades: 'Humor and Curiosities',
    CocinaVidaCotidiana: 'Cooking and Everyday Life',
    NaturalezaAnimales: 'Animals and Nature',
}
